const env = import.meta.env as Record<string, string | undefined>;

const requireEnv = (name: string): string => {
  const value = env[name]?.trim();
  if (!value) {
    throw new Error(`Missing required environment variable: ${name}`);
  }
  return value;
};

const optionalEnv = (name: string): string | undefined => {
  const value = env[name]?.trim();
  return value || undefined;
};

export const API_BASE_URL = requireEnv('VITE_SMARTDOCS_API_BASE_URL');
export const BACKEND_BASE_URL = API_BASE_URL.replace(/\/api\/v1\/?$/, '');
const websocketUrl =
  optionalEnv('VITE_CONTRACTOR_WEBSOCKET_URL') ??
  optionalEnv('VITE_SMARTDOCS_WEBSOCKET_URL');

if (!websocketUrl) {
  throw new Error(
    'Missing required environment variable: VITE_CONTRACTOR_WEBSOCKET_URL or VITE_SMARTDOCS_WEBSOCKET_URL'
  );
}

export const WEBSOCKET_URL = websocketUrl;
